export const SYNC_TWR_DEVICES_BY_GROUPS = '@@twrDevicesByGroups/syncTwrDevicesByGroups'

export const RESET_TWR_DEVICES_BY_GROUPS = '@@twrDevicesByGroups/reset'

export const UPDATE_TWR_DEVICES_BY_GROUPS = '@@twrDevicesByGroups/updateTwrDevicesByGroups'
